export const OrderStatus = {
  pending: "pending",
  processing: "progress",
  completed: "completed",
  canseled: "cancelled",
};
